import * as S from './PreviewSpinner.styles'
import { theme } from 'mixtiles-web-common/elements/Theme/photosTheme'

export const SPINNER_SIZES = {
  fill: '100%',
  small: '20px',
  medium: '30px',
}

export default function PreviewSpinner({
  color = theme.colors.grayMidDark,
  size = SPINNER_SIZES.fill,
}) {
  return <S.Spinner color={color} size={size} />
}
